import {
  cardTitle,
  grayColor,
  warningColor,
} from "assets/jss/material-dashboard-pro-react.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

const BORDER = "1px solid rgba(0, 0, 0, 0.06)";
const BORDER_STRONG = "1px solid rgba(0, 0, 0, 0.10)";
const HEADER_BG = "#fbfbfc";
const STICKY_BG = "#ffffff";
const HEADER_TEXT = "#8a909c";

const accessManagementStyle = (theme) => ({
  ...customSelectStyle(theme),

  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },

  // --- Toolbar ---
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    gap: "14px",
    marginBottom: "18px",
  },
  searchField: {
    minWidth: "240px",
    margin: "0 !important",
    // Alinha o underline ao mesmo padrao do selectFormControl da app
    // (resting: grayColor[4]; focus: clientColor) para os dois filtros
    // ficarem com o mesmo tracado.
    "& .MuiInput-underline:before": {
      borderBottomColor: grayColor[4] + " !important",
      borderBottomWidth: "1px !important",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottomColor: grayColor[4] + " !important",
      borderBottomWidth: "1px !important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor:
        (theme.palette?.custom?.clientColor || grayColor[2]) + " !important",
    },
  },
  filterSelect: {
    minWidth: "180px",
    margin: "0 !important",
  },
  // Texto do trigger do select alinhado ao campo de busca:
  // mesma cor/caixa (sem o uppercase navy do customSelectStyle.select)
  filterSelectText: {
    "& .MuiSelect-select": {
      fontSize: "0.875rem",
      textTransform: "none",
      color: grayColor[2],
      paddingTop: "6px",
      paddingBottom: "7px",
      "&:focus": {
        backgroundColor: "transparent",
      },
    },
  },
  toolbarSpacer: {
    flex: "1 1 auto",
  },
  toolbarTextButton: {
    fontSize: "12px !important",
    color: HEADER_TEXT + " !important",
    textTransform: "none !important",
    fontWeight: "400 !important",
  },

  // Botao Salvar — replica do UserManagement antigo (icone + efeito attention)
  cardButton: {
    padding: "0 !important",
    margin: "15px 0 0 10px !important",
    height: "22px !important",
    width: "30px !important",
    minWidth: "0 !important",
    position: "relative",
    transition: "all 0.2s",
    backgroundColor: theme.palette.custom.clientColor + " !important",
    color: theme.palette.custom.clientTextColor + " !important",
  },
  cardButtonIcon: {
    margin: "0 !important",
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%)",
    width: "18px !important",
    height: "18px !important",
    color: "#FFFFFF",
  },
  actionDisabled: {
    opacity: "0.5 !important",
    pointerEvents: "none",
  },
  "@keyframes loadingAnimation": {
    "0%": { backgroundColor: grayColor[4] },
    "25%": { backgroundColor: grayColor[3] },
    "50%": { backgroundColor: grayColor[4] },
    "75%": { backgroundColor: grayColor[3] },
    "100%": { backgroundColor: grayColor[4] },
  },
  loadingAnimation: {
    animation: "$loadingAnimation 4.0s ease-in-out infinite",
  },
  attention: {
    backgroundColor: warningColor[0] + " !important",
    animation: "$attention 3s ease infinite",
  },
  "@keyframes attention": {
    "10%": { transform: "scale(1.1)" },
    "13.33%,20%": { transform: "rotate(-10deg) scale(1.1)" },
    "16.67%": { transform: "rotate(10deg) scale(1.1)" },
    "23.33%": { transform: "rotate(0deg) scale(1.1)" },
    "33%": { transform: "scale(1)" },
  },
  // Destaque de usuario com alteracao pendente
  dirtyUserCell: {
    boxShadow: `inset 3px 0 0 ${warningColor[0]}`,
  },

  // --- Tabela estilo planilha ---
  tableWrapper: {
    overflowX: "auto",
    border: BORDER,
    borderRadius: "6px",
    maxHeight: "65vh",
  },
  table: {
    borderCollapse: "separate",
    borderSpacing: 0,
    width: "100%",
    fontSize: "12px",
    fontWeight: 300,
    color: grayColor[2],
  },

  // Cabecalho de grupo (bloco) - linha superior
  groupHeaderCell: {
    position: "sticky",
    top: 0,
    zIndex: 5,
    backgroundColor: HEADER_BG,
    borderBottom: BORDER,
    borderLeft: BORDER,
    padding: "9px 10px",
    fontWeight: 600,
    fontSize: "10.5px",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: HEADER_TEXT,
    cursor: "pointer",
    whiteSpace: "nowrap",
    userSelect: "none",
    textAlign: "center",
    transition: "background-color 0.15s, color 0.15s",
    "&:hover": {
      backgroundColor: "#f3f4f6",
      color: grayColor[2],
    },
  },
  groupHeaderInner: {
    display: "inline-flex",
    alignItems: "center",
    gap: "3px",
  },

  // Cabecalho de coluna (atomo) - segunda linha
  atomHeaderCell: {
    position: "sticky",
    top: "35px",
    zIndex: 5,
    backgroundColor: STICKY_BG,
    borderBottom: BORDER_STRONG,
    borderLeft: BORDER,
    padding: "6px 6px",
    fontWeight: 400,
    fontSize: "11px",
    color: grayColor[1],
    textAlign: "center",
    whiteSpace: "nowrap",
    minWidth: "48px",
    cursor: "help",
  },
  dangerHeader: {
    color: theme.palette?.custom?.clientColor || grayColor[6],
    fontWeight: 500,
  },
  // Cabecalho da coluna agregada (sub-bloco com "selecionar tudo")
  aggHeaderCell: {
    fontWeight: 600,
    color: grayColor[2],
  },
  // Borda esquerda mais forte para marcar inicio de um sub-bloco
  groupStartCell: {
    borderLeft: `1px solid ${grayColor[5]} !important`,
  },

  // Coluna fixa do usuario (freeze pane)
  userColHeader: {
    position: "sticky",
    left: 0,
    top: 0,
    zIndex: 7,
    backgroundColor: HEADER_BG,
    borderBottom: BORDER,
    borderRight: BORDER_STRONG,
    padding: "9px 14px",
    minWidth: "220px",
    textAlign: "left",
    fontWeight: 600,
    fontSize: "10.5px",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: HEADER_TEXT,
  },
  presetColHeader: {
    position: "sticky",
    left: "220px",
    top: 0,
    zIndex: 7,
    backgroundColor: HEADER_BG,
    borderBottom: BORDER,
    borderRight: BORDER_STRONG,
    padding: "9px 14px",
    minWidth: "170px",
    fontWeight: 600,
    fontSize: "10.5px",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: HEADER_TEXT,
  },

  // Corpo
  bodyRow: {
    "&:hover td": {
      backgroundColor: grayColor[12],
    },
  },
  userCell: {
    position: "sticky",
    left: 0,
    zIndex: 3,
    backgroundColor: STICKY_BG,
    borderRight: BORDER_STRONG,
    borderBottom: BORDER,
    padding: "6px 10px",
    minWidth: "220px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  userTextWrap: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  userName: {
    fontWeight: 400,
    fontSize: "12px",
    color: grayColor[2],
    lineHeight: 1.3,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  userEmail: {
    fontSize: "10.5px",
    color: grayColor[0],
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  presetCell: {
    position: "sticky",
    left: "220px",
    zIndex: 3,
    backgroundColor: STICKY_BG,
    borderRight: BORDER_STRONG,
    borderBottom: BORDER,
    padding: "2px 8px",
    minWidth: "160px",
  },
  presetCellInner: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  // Select de preset estilo "celula editavel" (borderless, hover sutil)
  presetSelect: {
    fontSize: "12.5px",
    borderRadius: "7px",
    transition: "background-color 0.15s",
    "& .MuiSelect-select": {
      fontSize: "12.5px",
      paddingTop: "6px",
      paddingBottom: "6px",
      paddingLeft: "8px",
      borderRadius: "7px",
      color: grayColor[2],
      "&:focus": {
        backgroundColor: "transparent",
      },
    },
    "& .MuiSelect-icon": {
      color: grayColor[3],
    },
    "&:hover": {
      backgroundColor: "#f3f4f6",
    },
  },
  copyIcon: {
    cursor: "pointer",
    color: grayColor[3],
    fontSize: "15px",
    flexShrink: 0,
    transition: "color 0.15s",
    "&:hover": {
      color: theme.palette?.custom?.clientColor || grayColor[2],
    },
  },
  // Menu "copiar de" — denso e minimalista
  copyMenuPaper: {
    maxHeight: "340px",
    minWidth: "240px",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
  },
  copyMenuHeader: {
    fontSize: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: grayColor[0],
    padding: "8px 16px 4px",
    pointerEvents: "none",
    opacity: 1,
  },
  copyMenuItem: {
    fontSize: "12.5px",
    color: grayColor[2],
    paddingTop: "5px",
    paddingBottom: "5px",
    minHeight: "auto",
  },
  copyMenuItemPreset: {
    fontSize: "10.5px",
    color: grayColor[0],
    marginLeft: "6px",
  },
  bodyCell: {
    textAlign: "center",
    borderLeft: BORDER,
    borderBottom: BORDER,
    padding: "0",
  },
  summaryCell: {
    textAlign: "center",
    borderLeft: BORDER,
    borderBottom: BORDER,
    padding: "0",
    fontSize: "11px",
    color: grayColor[1],
    cursor: "pointer",
  },
  summaryFull: {
    color: theme.palette?.custom?.clientColor || grayColor[6],
    fontWeight: 500,
  },
  summaryPartial: {
    color: grayColor[1],
  },
  summaryEmpty: {
    color: grayColor[4],
  },

  // Scope
  scopeHeaderCell: {
    position: "sticky",
    top: 0,
    zIndex: 5,
    backgroundColor: HEADER_BG,
    borderBottom: BORDER,
    borderLeft: BORDER_STRONG,
    padding: "9px 14px",
    fontWeight: 600,
    fontSize: "10.5px",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: HEADER_TEXT,
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  scopeCell: {
    whiteSpace: "nowrap",
    padding: "4px 14px",
    borderLeft: BORDER_STRONG,
    borderBottom: BORDER,
    cursor: "pointer",
  },
  // Texto do scope quando ha restricao (cor do cliente, discreto)
  scopeText: {
    fontSize: "11.5px",
    color: theme.palette?.custom?.clientColor || grayColor[6],
    "&:hover": { textDecoration: "underline" },
  },
  // Placeholder "definir" quando sem restricao
  scopeEmpty: {
    fontSize: "11.5px",
    color: grayColor[4],
    "&:hover": {
      color: grayColor[1],
      textDecoration: "underline",
    },
  },

  // Bulk bar
  bulkBar: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "10px 14px",
    marginTop: "12px",
    backgroundColor: grayColor[13],
    borderRadius: "6px",
    border: BORDER,
  },
  bulkLabel: {
    fontWeight: 500,
    fontSize: "13px",
    color: grayColor[2],
  },
  bulkOr: {
    fontSize: "12px",
    color: grayColor[1],
    fontStyle: "italic",
  },

  // Tooltip
  permTooltipTitle: {
    fontSize: "12px",
    fontWeight: 600,
  },
  permTooltipDesc: {
    fontSize: "11px",
    fontWeight: 300,
    marginTop: "2px",
  },

  spinnerWrap: {
    display: "flex",
    justifyContent: "center",
    padding: "40px",
  },
});

export default accessManagementStyle;
